import {APP_CLEAR, COURSES_SET_LIST, COURSES_CHOOSE, COURSES_CANCELCHOOSE, COURSES_SEARCHING, USER_SET_AGENT} from '../constants/actionTypes';

const initialState ={
  courses: [],
  filter: null,
  currCourse: null,
  infoText: "Wyszukaj połączenia",
};

const coursesReducer = (state = initialState, action) => {  
  switch (action.type) {  
    case COURSES_SEARCHING:
      return {
        ...state,
        courses: [],
        infoText: "Wyszukiwanie ..."
      }  
    case COURSES_SET_LIST:      
      return {
        ...state, 
        courses: action.courses,
        filter: action.filter,
        currCourse: null,
        infoText: ((action.courses.length>0)?"":"Brak kursów spełniających wybrane kryteria")
      }
    case COURSES_CHOOSE:  
      var idx=action.courseIndex
      if (idx>=0)
        if (idx<state.courses.length)        
          return {
          ...state,
          currCourse: state.courses[idx],
        }        
      return state;
    case COURSES_CANCELCHOOSE:
      return {
          ...state,
          currCourse: null,
        }
    case USER_SET_AGENT:
    case APP_CLEAR:
      return {
          ...state, 
          ...initialState
        }    
    default:
      return state;
   }
};
 
export default coursesReducer;


// WEBPACK FOOTER //
// ./src/reducers/coursesReducer.js